import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Components Imports
import ContextMenuItems from "../ContextMenuItems";
import GroupTitleComponent from "./GroupTitle/GroupTitle";
import RowRenderer from "./RowRenderer/RowRenderer";

export default class CustomGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: {
        visible: false,
        x: 0,
        y: 0,
      },
    };
  }

  componentDidMount() {
    this.resizeTable();
  }

  componentDidUpdate() {
    this.resizeTable();
  }

  /* Resize Table header according to requirement */
  resizeTable = () => {
    let thElm;
    let startOffset;
    Array.prototype.forEach.call(
      document.getElementsByClassName("revv-divtablehead"),
      th => {
        th.style.position = "relative";
        const grip = document.createElement("div");
        grip.innerHTML = "&nbsp;";
        grip.style.top = 0;
        grip.style.right = 0;
        grip.style.bottom = 0;
        grip.style.width = "5px";
        grip.style.position = "absolute";
        grip.style.cursor = "col-resize";
        grip.addEventListener("mousedown", e => {
          thElm = th;
          startOffset = th.offsetWidth - e.pageX;
        });
        th.appendChild(grip);
      },
    );
    document.addEventListener("mousemove", e => {
      if (thElm) {
        thElm.style.minWidth = `${startOffset + e.pageX}px`;
      }
    });
    document.addEventListener("mouseup", () => {
      thElm = undefined;
    });
  };

  onCellValueChanged = (value, columnData, row, rowIndex) => {
    const oldValue = row.rowData[columnData.field].cellData;
    const newValue = value;
    console.debug("onCellValueChanged in Custom grid");
    if (this.props.onCellValueChanged && oldValue !== newValue) {
      // Update the cell value & pass the updated value as callback to component
      row.rowData[columnData.field].cellData = value;

      this.props.onCellValueChanged({
        columnData,
        row,
        rowIndex,
        oldValue,
        newValue,
      });
    }
  };

  onRowHandle = (event, rowRecord, cellRecord, groupMeta, groupLength) => {
    event.preventDefault();
    const that = this;
    that.setState({
      popup: {
        rowRecord,
        visible: true,
        x: event.clientX,
        y: event.clientY,
      },
    });
    /* That co is for => Recognize the selected Menu Item with close menu */
    document.addEventListener(`click`, function onClickInside(e) {
      console.debug("INTSIDE", that.state, e.srcElement.id);
      that.setState({ popup: { visible: false } });
      that.addMenuListeners(e, rowRecord, cellRecord, groupMeta, groupLength);
      document.removeEventListener(`click`, onClickInside);
    });
    console.debug("hi", event, rowRecord);
  };

  addMenuListeners = (e, rowRecord, cellRecord, groupMeta, groupLength) => {
    console.debug("addMenuListeners", e, rowRecord, cellRecord);
    // eslint-disable-next-line default-case
    switch (e.srcElement.id) {
      case "Delete":
        this.props.deleteRow(rowRecord, groupMeta, groupLength);
        break;
    }
  };

  onUpdatedDiscountValue = (meta, value) => {
    this.props.onUpdatedDiscountValue(meta, value);
  };

  sortData = col => {
    this.props.sortData(col);
  };

  transformYStyle = rowIndex => ({
    transform: `translateY(${rowIndex * 34}px)`,
    height: "34px",
  });

  render() {
    const self = this;
    const {
      columns,
      rows,
      groupReference,
      discount,
      currencyIcon,
    } = this.props;
    console.debug("groupReference", this.props);
    const groupDetailArray = [];
    if (groupReference && discount.groups.length > 0) {
      const rowsData = JSON.parse(JSON.stringify(rows));
      const groupData = rowsData.reduce((r, a) => {
        r[a.rowData[groupReference].cellData] =
          r[a.rowData[groupReference].cellData] || [];
        r[a.rowData[groupReference].cellData].push(a);
        return r;
      }, Object.create(null));
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(groupData)) {
        for (let v = 0; v < discount.groups.length; v += 1) {
          if (discount.groups[v].group_by_value === key) {
            groupDetailArray.push({
              groupName: key,
              groupDataDetails: value,
              groupMeta: discount.groups[v],
            });
          }
        }
      }
      console.debug("convertArray", groupData, groupDetailArray);
    }

    console.debug("qweqe", this.props.rows);

    return (
      <Fragment>
        <ContextMenuItems
          {...this.state.popup}
          onSelectItem={this.onSelectItem}
        />
        {/* <div className="tablewrapper">
          <table id="tableId">
            <thead className="table-thead">
              <tr>
                {columns.length > 0 ? <th>#</th> : null}
                {columns.map(col => (
                  <th
                    style={
                      col.hidden === true
                        ? { display: "none" }
                        : { display: "", cursor: "pointer" }
                    }
                    onClick={() => self.sortData(col)}>
                    {col.label}
                    <span className="">
                      {col.sortStatus && (
                        <FontAwesomeIcon icon={["fas", col.sortStatus]} />
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {groupReference && discount.groups.length > 0
                ? groupDetailArray.map(group => (
                    <Fragment>
                      <tr className="fixedgroup">
                        <div>
                          <GroupTitleComponent
                            groupName={group.groupName}
                            groupLength={group.groupDataDetails.length}
                            groupMeta={group.groupMeta}
                            currencyIcon={currencyIcon}
                            onUpdatedDiscountValue={self.onUpdatedDiscountValue}
                          />
                        </div>
                      </tr>
                      {group.groupDataDetails.map((row, rowIndex) => (
                        <Fragment>
                          <tr className="table-tr">
                            <td
                              onContextMenu={event =>
                                self.onRowHandle(event, row)
                              }>
                              {rowIndex + 1}
                            </td>
                            {columns.map((col, colIndex) => (
                              <RowRenderer
                                row={row}
                                col={col}
                                colIndex={colIndex}
                                rowIndex={rowIndex}
                                groupMeta={group.groupMeta}
                                groupLength={group.groupDataDetails.length}
                                onCellValueChanged={this.onCellValueChanged}
                                openPopup={this.props.openPopup}
                                deleteRow={this.props.deleteRow}
                              />
                            ))}
                          </tr>
                        </Fragment>
                      ))}
                    </Fragment>
                  ))
                : rows.map((row, rowIndex) => (
                    <Fragment>
                      <tr className="table-tr">
                        <td
                          onContextMenu={event => self.onRowHandle(event, row)}>
                          {rowIndex + 1}
                        </td>
                        {columns.map((col, colIndex) => (
                          <RowRenderer
                            row={row}
                            col={col}
                            colIndex={colIndex}
                            rowIndex={rowIndex}
                            onCellValueChanged={this.onCellValueChanged}
                            openPopup={this.props.openPopup}
                            deleteRow={this.props.deleteRow}
                          />
                        ))}
                      </tr>
                    </Fragment>
                  ))}
            </tbody>
          </table>
        </div> */}
        <div className="tablewrapper">
          <div className="revv-divtable" id="tableId">
            <div className="revv-divtablebody">
              <div className="revv-divtableheading">
                {columns.length > 0 ? (
                  <div className="revv-divtablehead revv-divtablecount">#</div>
                ) : null}
                {columns.map(col => (
                  <div
                    className="revv-divtablehead"
                    style={
                      col.hidden === true
                        ? { display: "none" }
                        : { display: "", cursor: "pointer" }
                    }>
                    {col.label}
                    <span className="">
                      {col.sortStatus && (
                        <FontAwesomeIcon icon={["fas", col.sortStatus]} />
                      )}
                    </span>
                  </div>
                ))}
              </div>
              <div className="revv-divtablebody">
                {groupReference && discount.groups.length > 0
                  ? groupDetailArray.map(group => (
                      <Fragment>
                        <div className="revv-divtablerow table-tr">
                          <div className="fixedgroup-wrapper">
                            <div className="fixedgroup">
                              <GroupTitleComponent
                                groupName={group.groupName}
                                groupLength={group.groupDataDetails.length}
                                groupMeta={group.groupMeta}
                                currencyIcon={currencyIcon}
                                onUpdatedDiscountValue={
                                  self.onUpdatedDiscountValue
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {group.groupDataDetails.map((row, rowIndex) => (
                          <Fragment>
                            <div className="revv-divtablerow table-tr">
                              <div
                                className="revv-divtablecell revv-divtablecount"
                                onContextMenu={event =>
                                  self.onRowHandle(event, row)
                                }>
                                {rowIndex + 1}
                              </div>
                              {columns.map((col, colIndex) => (
                                <RowRenderer
                                  row={row}
                                  col={col}
                                  colIndex={colIndex}
                                  rowIndex={rowIndex}
                                  groupMeta={group.groupMeta}
                                  groupLength={group.groupDataDetails.length}
                                  onCellValueChanged={this.onCellValueChanged}
                                  openPopup={this.props.openPopup}
                                  deleteRow={this.props.deleteRow}
                                />
                              ))}
                            </div>
                          </Fragment>
                        ))}
                      </Fragment>
                    ))
                  : rows.map((row, rowIndex) => (
                      <Fragment>
                        <div
                          className="revv-divtablerow table-tr row-position-absolute"
                          style={this.transformYStyle(rowIndex)}>
                          <div
                            className="revv-divtablecell revv-divtablecount"
                            onContextMenu={event =>
                              self.onRowHandle(event, row)
                            }>
                            {rowIndex + 1}
                          </div>
                          {columns.map((col, colIndex) => (
                            <RowRenderer
                              row={row}
                              col={col}
                              colIndex={colIndex}
                              rowIndex={rowIndex}
                              onCellValueChanged={this.onCellValueChanged}
                              openPopup={this.props.openPopup}
                              deleteRow={this.props.deleteRow}
                            />
                          ))}
                        </div>
                      </Fragment>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/CustomGrid.js